import moment from "moment";

export const labelDate = (date) => {
	if (date) {
		const deadline = moment(date).parseZone().format("YYYY-MM-DD");
		const label = [];

		if (deadline === moment().format("YYYY-MM-DD")) {
			label.push("today");
		}
		if (deadline === moment().add(1, "days").format("YYYY-MM-DD")) {
			label.push("tomorrow");
		}
		if (moment().isoWeek() == moment(deadline).isoWeek()) {
			label.push("thisWeek");
		}

		return label;
	}
};
